import apiClient from '../core';

export interface PublicUser {
  id: string;
  name: string;
  email: string;
  isAdmin: boolean;
  emailVerified: boolean;
  competeStudioId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const usersApi = {
  async linkCompeteStudio(competeStudioId: string): Promise<PublicUser> {
    const response = await apiClient.post<{
      success: boolean;
      data: PublicUser;
      message?: string;
    }>('/users/me/studio-link', { competeStudioId });
    return response.data.data;
  },
};
